import { render, staticRenderFns } from "./UserUpdateForm.vue?vue&type=template&id=048fd7aa&"
import script from "./UserUpdateForm.vue?vue&type=script&lang=js&"
export * from "./UserUpdateForm.vue?vue&type=script&lang=js&"
import style0 from "./UserUpdateForm.vue?vue&type=style&index=0&id=048fd7aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports